export default __webpack_public_path__ + "static/media/ic-instruction-03.0466c974.svg";